import { render, staticRenderFns } from "./msg-template.vue?vue&type=template&id=5d910998&scoped=true&"
import script from "./msg-template.vue?vue&type=script&lang=js&"
export * from "./msg-template.vue?vue&type=script&lang=js&"
import style0 from "./msg-template.vue?vue&type=style&index=0&id=5d910998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d910998",
  null
  
)

export default component.exports